import cx from "classnames";
import React from "react";

import Sticker, { StickerSize } from "@/mk2/components/Sticker";
import {
    ADD_PRODUCTS_BANNER_DESCRIPTION,
    ADD_PRODUCTS_BANNER_TITLE,
} from "@/mk/autogenerated/translations/AddProductsBanner.f590580d2b60ff4a7bf8681aea49f963";

import styles from "./AddProductsBanner.mscss";

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

const AddProductsBanner: React.FunctionComponent<Props> = ({ className }) => (
    <div className={cx(styles.AddProductsBanner, className)}>
        <h2 className={styles.AddProductsBanner__title}>{ADD_PRODUCTS_BANNER_TITLE}</h2>
        <div className={styles.AddProductsBanner__image}>
            <Sticker id={41} size={StickerSize.XL} />
        </div>
        <div className={styles.AddProductsBanner__description}>
            {ADD_PRODUCTS_BANNER_DESCRIPTION}
        </div>
    </div>
);

AddProductsBanner.displayName = "AddProductsBanner";

export default AddProductsBanner;
